import styles from './linkset.module.scss';
import { Link, type LinkProps } from '@/ui-components/atoms/Link/Link';
import cn from 'classnames';

export interface LinkSetProps {
    links: LinkProps[];
    heading?: string;
    variant?: 'small' | 'large';
    isdarkTheme?: boolean;
}

export function LinkSet({ links, heading, variant = 'large', isdarkTheme }: LinkSetProps): React.JSX.Element {
    const classNames = cn(styles.linkSet, {
        [styles.smallLinkSet]: variant === 'small',
    });
    const wrapperClassNames = cn(styles.container, {
        [styles.darkTheme]: isdarkTheme,
    });
    return (
        <div className={wrapperClassNames}>
            {heading && <span className={variant === 'small' ? styles.smallSpan : ''}>{heading}</span>}
            <ul className={classNames}>
                {links.map((link, i) => {
                    return (
                        <li key={i}>
                            <Link {...link} ref={null} />
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}
